import React, { useEffect } from "react";
import { Checklist as UIChecklist } from "../../../components/ui";

/**
 * Super timesheet checklist: requirements for the super to confirm and submit.
 * Uses generic Checklist from ui with super-timesheet-specific conditions.
 * Sets isSubmittable in parent when all requirements are met.
 */
const Checklist = ({
  workerTimesheet = false,
  hoursLog = false,
  hasConflicts = false,
  missingLogs = false,
  isEditing = false,
  isManagerSigned = false,
  setIsSubmittable = () => {},
  maxJobsExceeded = false,
  className,
}) => {
  useEffect(() => {
    setIsSubmittable(
      workerTimesheet && hoursLog && !isEditing && isManagerSigned && !maxJobsExceeded
    );
  }, [
    workerTimesheet,
    hoursLog,
    isEditing,
    isManagerSigned,
    maxJobsExceeded,
    setIsSubmittable,
  ]);

  const conditions = [
    {
      met: !(hasConflicts && isEditing),
      message: "Manager daily log and worker hours mismatch detected.",
    },
    {
      met: !(missingLogs && isEditing),
      message: "Hours logs not found for some shifts.",
    },
    {
      met: !isEditing,
      message: "Please finish editing and confirm the payout version.",
    },
    {
      met: isManagerSigned || isEditing,
      message: "Please sign the timesheet in the manager box.",
    },
    {
      met: !maxJobsExceeded,
      message:
        "Max jobs supported by the PDF format has been exceeded. Please use 5 or less unique jobs.",
    },
  ];

  return (
    <UIChecklist
      className={`${className} p-2 pb-0`}
      conditions={conditions}
      successMessage="All requirements met! You can now submit the timesheet."
    />
  );
};

export default Checklist;
